module.exports = __webpack_public_path__ + "static/media/video_thumb5.d7807b00.svg";